<div class="fx-column">
  <span class="label" *ngIf="labelOutside">{{label}}</span>
  <div class="button" [class.active]="selection !== undefined" style="max-width:100%;" [cdkMenuTriggerFor]="menu"
    (cdkMenuOpened)="populate()" #trigger="cdkMenuTriggerFor" [class.disabled]="disabled">
    <div class="fx-row fx-flex-100 align-items-center justify-content-between label-container">
      <div class="text main label-container fx-flex" *ngIf="selection">{{selection}}</div>
      <div class="text label-container fx-flex" *ngIf="!selection">{{label}}</div>
      <mat-icon class="dark ml-5" fontSet="material-icons-outlined"
        *ngIf="!selection || !multiple">expand_more</mat-icon>
      <mat-icon class="main ml-5" fontSet="material-icons-outlined" *ngIf="selection && multiple"
        (click)="$event.stopPropagation();onClear();">clear</mat-icon>
    </div>
  </div>
  <ng-template #menu>
    <mat-card class="menu-container p-0 elevation" cdkMenu>
      <div class="fx-column" (click)="$event.stopPropagation()">
        <div>
          <div class="p-16">
            <div class="fx-row align-items-center justify-content-between mb-5">
              <span class="text bold" *ngIf="label">{{label | translate}}</span>
              <span class="small clickable" (click)="onClear();" *ngIf=" multiple">{{'ACTIONS.CLEAR'
                | translate}}</span>
            </div>
            <app-input placeholder="{{'ACTIONS.SEARCH' | translate}}..." type="text" prefix="search" class="mt-10"
              *ngIf="search" [(value)]="_filter" [autoFocus]="true"></app-input>
          </div>
          <mat-divider *ngIf="!search && multiple && filtered().length > 1"></mat-divider>
          <div class="flex-row align-items-center justify-content-start option-multiple"
            *ngIf="!search && multiple && filtered().length > 1">
            <mat-checkbox color="primary" [checked]="isAllSelected()" (change)="toggleAllSelection()">
            </mat-checkbox>
            <span class="text ml-5 option-label">{{(isAllSelected() ? 'ACTIONS.UNSELECT_ALL' : 'ACTIONS.SELECT_ALL') |
              translate}}</span>
          </div>
          <mat-divider></mat-divider>
        </div>
        <div class="options-container pv-16" *ngIf="multiple" [class.search]="search">
          <div class="fx-column" *ngIf="search && selectedToDisplay().length > 0">
            <div class="fx-row align-items-center justify-content-start clickable option-multiple actionable"
              *ngFor="let type of selectedToDisplay(); let index = index" (click)="removeFromPreselection(type)">
              <mat-checkbox color="primary" [checked]="type.selected">
              </mat-checkbox>
              <span class="text ml-5 option-label">{{'TRADEMARK.TYPES.'+type.value | translate}}</span>
            </div>
            <mat-divider></mat-divider>
          </div>
          <div class="fx-column">
            <div class="fx-row align-items-center justify-content-start clickable option-multiple"
              *ngFor="let type of filtered(); let index = index" (click)="type.disabled ? null : select(type)"
              [class.disabled]="type.disabled" [class.actionable]="search">
              <mat-checkbox color="primary" [checked]="type.selected">
              </mat-checkbox>
              <span class="text ml-5 option-label">{{'TRADEMARK.TYPES.'+type.value | translate}}</span>
            </div>
          </div>
          <div class="ph-16" *ngIf="filtered().length === 0">
            <span class="light text">{{'PAGINATOR.GENERIC_SEARCH_NO_RESULTS' | translate}}</span>
          </div>
        </div>
        <div class="options-container" *ngIf="!multiple" [class.search]="search">
          <div class="fx-column">
            <div class="fx-row align-items-center justify-content-start clickable option actionable p-16"
              *ngFor="let type of filtered(); let index = index" (click)="type.disabled ? null : select(type)"
              [class.disabled]="type.disabled" [class.selected]="type.selected">
              <span class="text option-label">{{'TRADEMARK.TYPES.'+type.value | translate}}</span>
            </div>
          </div>
          <div class="p-16" *ngIf="filtered().length === 0">
            <span class="light text">{{'PAGINATOR.GENERIC_SEARCH_NO_RESULTS' | translate}}</span>
          </div>
        </div>
      </div>
    </mat-card>
  </ng-template>
</div>